import { useEffect, useState } from 'react';

/* Menu badge "(1)" for Questions: unread messages. Checked when the page changes, every minute,
   and right after a conversation is opened (the pages send the 'rm-questions-read' event). */
export const QUESTIONS_READ = 'rm-questions-read';
export const questionsRead = () => {
  try {
    window.dispatchEvent(new Event(QUESTIONS_READ));
  } catch {
    /* old browsers: the badge updates on the next page change */
  }
};

const useUnread = (url, token, pathname) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!token || !url) return undefined;
    let alive = true;
    const load = () =>
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => alive && d && setCount(Number(d.unread) || 0))
        .catch(() => {});
    load();
    const id = setInterval(load, 60000);
    window.addEventListener(QUESTIONS_READ, load);
    return () => {
      alive = false;
      clearInterval(id);
      window.removeEventListener(QUESTIONS_READ, load);
    };
  }, [url, token, pathname]);
  return count;
};

export default useUnread;
